import { Component, OnInit, AfterContentInit, ViewChild, ElementRef, Input, HostBinding, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SLLayer } from 'src/app/model/sl-layer';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { SLMap } from 'src/app/model/sl-map';
import { StatefulCSS } from 'src/app/model/stateful_css';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { ViewStackComponent } from '../view-stack/view-stack.component';


import { ModalResultStyleService } from '../dialogs/modal-result-style/modal-result-style.service';
import { ResultsService, ResultMoment, ResultSetSrc } from 'src/app/services/results.service';
import { Synchable, SynchEvent, SynchSelectionsEvent, ISelectionInfo } from 'src/app/model/synchronizer';
import { SynchButtonComponent } from '../synch-button/synch-button.component';
import { UUID } from 'angular2-uuid';
import { features } from 'process';

@Component({
  selector: 'app-result-popup',
  templateUrl: './result-popup.component.html',
  styleUrls: ['./result-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultPopupComponent implements OnInit, AfterContentInit {

  public syncId = 'result-popup';
  public layerResultI = 0;
  public layerResultCount = 0;
  public resultI = 0;
  public resultCount = 0;
  public results: any;
  public currentLayerName = '';
  public currentLayerI = 0;
  public currentLayer: any = null;
  public currentSLLayer: SLLayer;
  public currentFeature: any = null;
  public currentFeatureI = 0;
  public tooltip = '';
  public slMap: SLMap;
  public isSettingSelections = false;
  public currentView = 'feature';
  public listSyncing = false;
  public listSyncingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public infoSyncing = false;
  public infoSyncingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isSynchingFeature = false;
  public moment: ResultMoment = null;
  public channel: number | string = '-1';
  public hasResults = false;
  public hasResultsChange = new EventEmitter<boolean>();
  public layersScrolling = false;
  // tslint:disable-next-line: variable-name
  private _showingInResults = false;

  private viewStates: StatefulCSS = new StatefulCSS();
  public synchProxy: Synchable;
  public selections: ISelectionInfo = null;

  public resultsAvailable = false;

  @Input() includeFeaturesButton: string;
  @HostBinding('class.result-popup') resultPopup = true;
  @ViewChild('resultArea', { static: true }) resultArea: ElementRef;
  @ViewChild('listSynchButton', { static: true }) listSynchButton: SynchButtonComponent;
  @ViewChild('infoSynchButton', { static: true }) infoSynchButton: SynchButtonComponent;
  @ViewChild('ddButton', { static: true }) ddButton: IconButtonComponent;
  @ViewChild('prevLayerButton', { static: true }) prevLayerButton: IconButtonComponent;
  @ViewChild('nextLayerButton', { static: true }) nextLayerButton: IconButtonComponent;
  @ViewChild('prevButton', { static: true }) prevButton: IconButtonComponent;
  @ViewChild('nextButton', { static: true }) nextButton: IconButtonComponent;
  // @ViewChild('showInResultsButton', { static: true }) SIRButton: IconButtonComponent;
  @ViewChild('layerNames', { static: true }) layerNames: ElementRef<HTMLDivElement>;
  @ViewChild('closeButton', { static: true }) closeButton: IconButtonComponent;
  @ViewChild('views', { static: true }) views: ViewStackComponent;

  private _hidden: boolean = false;
  @HostBinding('attr.closed')
  get closed(): boolean {
    return this._hidden;
  }
  set closed(isHidden: boolean) {
    this._hidden = true;
  }
  @Output() actions: EventEmitter<any> = new EventEmitter(true);
  public layerService: LayerApiService;

  public get element(): HTMLElement {
    return this.domNode.nativeElement;
  }

  public get isFeatureView(): boolean {
    if (!this.viewStates) return false;
    return this.viewStates.GetCurrentState() === 'features';
  }
  public get isLayersView(): boolean {
    if (!this.viewStates) return false;
    return this.viewStates.GetCurrentState() === 'layers';
  }


  private _ready = false;
  constructor(private domNode: ElementRef, private stylesService: ModalResultStyleService, private resultsSvc: ResultsService,
    private cdr: ChangeDetectorRef) {
    this.isSettingSelections = false;

    this.synchProxy = {
      synchId: this.syncId,
      channel: -1,
      synchables: ['result-list'],
      handler: (event: SynchEvent) => {
        this.HandleSynchEvent(event);
      }
    }
    this._showingInResults = this._showingInResults;
    this.resultsSvc.AddSynchable(this.synchProxy);
  }
  public HandleSynchEvent(event: SynchEvent) {

    if (['history', 'popup-control'].indexOf(event.source) > -1) {
      if (event.topic === 'moment-change') {
        if (this.moment && (this.moment.id === event.data.moment.id)) {
          this.moment = event.data.moment;
          if (event.data.selections && event.data.selections.layerId && event.data.selections.features) {
            let i = 0;
            this.moment.resultSet?.results.every((result: any, offset: number) => {
              if (result.layer == event.data.selections.layer.id) {
                i = offset;
                return false;
              }
              return true;
            });
            let fi = 0;
            this.moment.resultSet.results[i].features.every((feature: any, index: number) => {
              if (feature.gid == event.data.selections.features[0]) {
                fi = index;
                return false;
              }
              return true;
            })
            this.SelectLayer(i, fi);
          } else {
            if (this.currentLayerI > -1) {
              this.currentFeature = this.currentLayer.features[this.currentFeatureI - 1];
              this.resultArea.nativeElement.innerHTML = this.currentSLLayer.GetTooltipText(this.currentFeature);
            }
          }
        }
      }
      return;
    }


  }

  ngOnInit() {
    this.resultsAvailable = this.slMap.HasResultsView();
  }

  ngAfterContentInit() {
    this._ready = true;
    this.viewStates.SetPrefix('display');
    this.viewStates.AddState('features');
    this.viewStates.AddState('layers');
    this.viewStates.AddState('loading');
    this.viewStates.SetMachine(this.domNode.nativeElement);
    this.viewStates.SetState('loading');


    // this.SIRButton.ToggleClass('hidden', true);
    // this.ddButton.ChangeIcon('layer-group');
    this.Refresh();

  }
  Close() {
    this.listSyncing = false;
    if (!!this.listSynchButton) {
      this.listSynchButton.Toggle(this.listSyncing);
    }
    this.infoSyncing = false;
    if (!!this.infoSynchButton) {
      this.infoSynchButton.Toggle(this.infoSyncing);
    }
    /* const selections: ISelectionInfo = {
      id: UUID.UUID(),
      features: [],
      layer: null,
      layerId: null,
      selectionMode: 'single'
    };
    */

    const resultInfo: any = {
      results: this.results
    };

    if (!!this.currentSLLayer) {
      resultInfo.selectedLayer = this.currentSLLayer;
    }
    if (!!this.currentFeature) {
      resultInfo.selectedFeature = this.currentFeature.gid;
    }

    // this.listSyncing = false;
    // this.listSyncingChange.emit(false);
    // this.listSyncing = this.listSynchButton.synching;

    // this.slMap.src.UpdateQuerySelections(selections);
    this.actions.emit({ action: 'close', results: resultInfo });

  };
  IncludeSIRButton() {
    /*$(this.SIRButton.btn.nativeElement).on('click', (event) => {
      this.actions.emit({
        action: 'show-in-features',
        data: this.results,
        layerI: this.currentLayerI - 1,
        featureI: this.currentFeatureI - 1
      });
    });*/
    // this.SIRButton.ToggleClass('hidden', false);
  }

  UpdateFeature(layerId: string | number, featureId: string | number, feature: any) {
    let featureFound = false;
    for (const result of this.results) {
      if (result.layer === layerId) {
        for (const resultFeature of result.features) {
          if (resultFeature.gid === featureId) {
            result.features[result.features.indexOf(resultFeature)] = feature;
            featureFound = true;
          }
          if (featureFound === true) {
            break;
          }
        }
        if (featureFound === true) {
          break;
        }
      }
    }
    this.ShowFeature();

  }
  SetResults(map: SLMap, service: any, moment: ResultMoment) {
    service = service;
    this.slMap = map;

    // this.listSynchButton.Toggle(this.listSyncing);
    const results: Array<ResultSetSrc> = moment.resultSet.results;
    this.hasResults = true;
    if (results.length === 0) {
      this.currentLayerName = '';
      this.resultArea.nativeElement.innerHTML = '<div class="no-results">No results found</div>';
      this.hasResults = false;

      this.views.SetView('feature');
      this.viewStates.SetState('features');
    }
    // this.hasResultsChange.emit
    for (const result of results) {
      if (result.hasOwnProperty('plid')) {
        result.name = this.slMap.GetLayerById('' + result.plid, true).name;
        result.id = result.plid;
      } else {
        result.name = this.slMap.GetLayerById('' + result.layer, false).name;
        result.id = result.layer;
      }
    }
    this.moment = moment;
    this.resultsSvc.history.RegisterSynch('popup-control', this.moment.id);
    this.synchProxy.channel = this.moment.id;
    this.results = results;
    if (!this.isSettingSelections) {
      if (this.results.length > 0) {
        this.SelectLayer(0, 0);
        /*if (this.results[0].features.length > 0) {
          this.currentFeatureI = 0;
          this.currentFeature = this.results[0].features[0];
          this.ShowFeature();
        }*/

      }
    }
    this.Refresh();
    // this.ddButton.ToggleClass('invis', this.results.length <= 1);
  }

  SelectLayerLocally(i: number) {
    this.isSettingSelections = false;
    this.SelectLayer(i);
  }
  SelectLayer(i: number, featureI = null) {
    this.currentLayerI = i + 1;
    this.currentLayer = this.results[this.currentLayerI - 1];
    if (!!this.currentLayer.plid) {
      this.currentSLLayer = this.slMap.GetLayerById(this.currentLayer.plid, true);
    } else {
      this.currentSLLayer = this.slMap.GetLayerById(this.currentLayer.layer);
    }
    this.currentLayerName = this.currentSLLayer.name;
    if (this.currentLayer.features.length > 0) {
      if (featureI !== null) {
        this.currentFeature = this.currentLayer.features[featureI]
        this.currentFeatureI = featureI + 1;
      } else {
        if (!this.isSettingSelections) {
          this.currentFeature = this.currentLayer.features[0];
          this.currentFeatureI = 1;
        }
      }
    }
    this.SetStats();

    if (this.isSynchingFeature === false) {
      if (this.isSettingSelections === false) {
        this.ShowFeature(true);
      }
    }

  }
  SetStats() {
    this.layerResultCount = this.results.length;
    this.layerResultI = this.currentLayerI;
    this.resultCount = this.currentLayer.features.length;
    this.resultI = this.currentFeatureI;
    this.Refresh();

  }
  ShowFeature(force = false) {
    if (force === true) this.isSettingSelections = false;
    this.viewStates.SetState('features');
    this.Refresh();
    this.resultArea.nativeElement.innerHTML = this.currentSLLayer.GetTooltipText(this.currentFeature);
    this.views.SetView('feature');
    this.currentView = 'feature';
    this.Refresh();

    if (!(!!this.currentLayer)) {
      return;
    }

    const unfeatures = [];
    for (const feature of this.currentLayer.features) {
      if (feature.gid !== this.currentFeature.gid) {
        unfeatures.push(feature.gid);
      }
    }
    const synchTo: Array<string> = [];
    if (this.listSyncing === true) {
      synchTo.push('results-list');
    }
    if (this.infoSyncing === true) {
      synchTo.push('info');
    }
    if (this.isSynchingFeature === false) {
      const info: ISelectionInfo = {
        id: UUID.UUID(),
        layerId: this.currentSLLayer.identifier,
        layer: this.currentSLLayer,
        features: [this.currentFeature.gid],
        unfeatures: (unfeatures),
        selectionMode: 'single'
      }
      this.resultsSvc.history.RegisterSelection('popup-control', info.id);


      const renderEvent: SynchSelectionsEvent = {
        channel: 'renderer',
        data: {
          moment: this.moment,
          selections: info
        },
        source: this.synchProxy.synchId,
        topic: 'render-request',
        synchFrom: this.synchProxy.synchId
      }

      this.resultsSvc.Synch(renderEvent);

      if (this.isSettingSelections === true) {
        return;
      }

      /*
      this.slMap.ShowResult({
        layerId: this.currentSLLayer.identifier,
        layer: this.currentSLLayer,
        features: [this.currentFeature.gid],
        unfeatures: (unfeatures),
        channel: this.synchProxy.channel,
        context: 'result-popup-selection'
      });
      */



      if (this.selections !== null) {
        if (this.resultsSvc.CompareSelections(this.selections, info)) {
          return;
        }
      }
      this.selections = info;

      // this.ddButton.ChangeIcon('layer-group');

      if (synchTo.length > 0) {
        const event: SynchSelectionsEvent = {
          channel: this.moment.id,
          data: {
            moment: this.moment,
            selections: info
          },
          source: this.synchProxy.synchId,
          topic: 'selection-change',
          synchTo: (synchTo.join(',')),
          synchFrom: this.synchProxy.synchId
        }

        this.resultsSvc.Synch(event);
      }
    }
    /*this.slMap.UpdateQuerySelections(
      {
        layerId: this.currentSLLayer.identifier,
        layer: this.currentSLLayer.id,
        features: [this.currentFeature.gid]
      }
    );*/
    this.viewStates.SetState('features');
    this.Refresh();




  }
  ShowFromResults(info: any) {
    this.isSettingSelections = true;
    if (info.results.length === 0) {
      this.resultArea.nativeElement.innerHTML = 'No results available';
    }
    this.currentSLLayer = info.selectedLayer;
    this.currentLayer = null;
    this.currentLayerI = -1;
    this.currentFeature = null;
    this.currentFeatureI = -1;
    this.results = info.results;
    this.SetResults(this.slMap, {}, info);
    this.Refresh();


    if (!!info.selectedLayer) {
      let l = -1;
      for (const layer of this.results) {
        l += 1;
        if (!!info.plid) {
          if (info.plid === layer.plid) {
            this.SelectLayer(l);
            break;
          }
        } else {
          if (info.id === layer.id) {
            this.SelectLayer(l);
            break;
          }
        }
      }
      let selectedFeature = null;
      if (!!info.selectedFeatures) {
        if (info.selectedFeatures.length > 0) {
          selectedFeature = info.selectedFeatures[0];
        }
      } else {
        if (!!info.selectedFeature) {
          selectedFeature = info.selectedFeature;
        }
      }
      if (selectedFeature !== null) {
        while (this.Next(false) !== null) {
          if (this.currentFeature.gid === info.selectedFeature) {
            this.ShowFeature();
          }
        }
      }
    }
    this.isSettingSelections = false;
    this.Refresh();

  }

  ShowInResults() {
    this.actions.emit({
      action: 'show-in-results', results: {
        results: this.results,
        selectedLayer: this.currentSLLayer,
        selectedFeature: this.currentFeature.gid
      }
    });

    this._showingInResults = true;

  }
  LoadFromResults() {
    this.actions.emit({
      action: 'load-from-results'
    });
  }
  ShowInInfo() {
    this.actions.emit({
      action: 'show-in-info', results: {
        results: this.results,
        selectedLayer: this.currentSLLayer,
        selectedFeature: this.currentFeature.gid
      }
    });
  }
  LoadFromInfo() {
    this.actions.emit({
      action: 'load-from-info'
    });
  }
  get hasNext(): boolean {
    if (this.hasResults === false) {
      return false;
    }
    return this.currentLayer?.features?.length > this.currentFeatureI;
  }
  get hasPrev(): boolean {
    if (this.hasResults === false) {
      return false;
    }
    return (this.currentFeatureI > 1) && (this.currentLayer?.features.length > 1);
  }
  get singleFeature():boolean {
    return this.currentLayer?.features?.length <= 1;
  }

  get singleLayer():boolean {
    return this.moment?.resultSet?.layerCount <= 1;
  }
  get hasNextLayer(): boolean {
    if (this.hasResults === false) {
      return false;
    }
    if (!this.viewStates) return false;
    if (this.viewStates.GetCurrentState() === 'layers') return false;

    if (!this.currentLayerI) {
      return false;
    }
    if (!this.layerResultCount) {
      return false;
    }
    return this.currentLayerI < this.layerResultCount;
  }
  get hasPrevLayer(): boolean {
    if (this.hasResults === false) {
      return false;
    }
    if (!this.viewStates) return false;
    if (this.viewStates.GetCurrentState() === 'layers') return false;
    /*if (this.views.currentView.viewName === 'layers') {
      return false;
    }*/
    if (!this.currentLayerI) {
      return false;
    }

    return this.currentLayerI > 1;
  }
  NextLayer(_update: boolean = true) {
    if (!this.hasNextLayer) {
      this.currentLayerI = 0;
      this.SelectLayer(this.currentLayerI);
      return;
    }
    if (!this.viewStates) return false;
    if (this.viewStates.GetCurrentState() === 'layers') return false;

    this.SelectLayerLocally(this.currentLayerI);
  }
  PrevLayer(update: boolean = true) {
    update = update;
    if (!this.hasPrevLayer) {
      this.currentLayerI = this.moment.resultSet.layerCount - 1;
      this.SelectLayer(this.currentLayerI);
      return;
    }
    this.SelectLayerLocally(this.currentLayerI - 2);
  }
  Next(update: boolean = true) {

    this.currentFeatureI++;
    if (this.currentLayer.features.length <= this.currentFeatureI - 1) {
      this.currentFeatureI = 1;
      // return null;
    }
    this.currentFeature = this.currentLayer.features[this.currentFeatureI - 1];
    if (update === true) {
      this.SetStats();
      this.ShowFeature(true);
    }
    return this.currentFeature;
  }
  Prev() {
    if (!this.hasPrev) {
      this.currentFeatureI = this.currentLayer.features.length + 1;
    }
    this.currentFeatureI--;
    this.currentFeature = this.currentLayer.features[this.currentFeatureI - 1];
    this.SetStats();
    this.ShowFeature(true);
  }
  ShowLayers() {
    if (this.views.currentView.viewName === 'layers') {
      this.views.SetView('feature');
      this.currentView = 'feature';
      //this.ddButton.ChangeIcon('layer-group');
    } else {
      this.views.SetView('layers');
      this.currentView = 'layers';
      // this.ddButton.ChangeIcon('map-marker');
    }
    this.viewStates.SetState('layers');
    this.Refresh();
  }
  ZoomToFeature() {
    this.slMap.component.HandleToolAction({
      action: 'info/zoom-to-features',
      layer: this.currentLayer.layer,
      features: this.currentFeature.gid
    });
  }
  Config() {
    let type = 'selected';
    const isPLayer = !!this.currentLayer.plid;
    const layer: SLLayer = this.slMap.GetLayerById(isPLayer ? this.currentLayer.plid : this.currentLayer.lid, isPLayer);
    if (layer.type === 9002) {
      type = 'selected';
    }
    if (layer.type === 9003) {
      type = 'unselected';
    }
    this.stylesService.GetStyles((data: any) => {
      data = data;
      layer.Render();
      this.slMap.UpdateResults();
      this.Refresh();
    }, this.slMap, type);
    this.Refresh();
  }
  HandleListSynchChange(syncing: boolean) {
    this.Refresh();
    if (syncing) {
      this.infoSyncing = false;
      this.infoSyncingChange.emit(this.infoSyncing);

      const features = [this.currentFeature.gid];
      if (!this.currentSLLayer) {
        return;
      }

      const info: ISelectionInfo = {
        id: UUID.UUID(),
        layer: this.currentSLLayer,
        layerId: this.currentSLLayer.id,
        features: (features),
        selectionMode: 'single'
      }
      if (this.selections !== null) {
        if (this.resultsSvc.CompareSelections(this.selections, info) === true) {
          return;
        }
      }
      this.selections = info;
      this.resultsSvc.Synch(
        {
          channel: this.moment.id,
          source: this.synchProxy.synchId,
          data: {
            moment: this.moment, selections: info
          },
          topic: 'selection-change'
        }
      )
    }

    // do something interesting
  }
  HandleInfoSynchChange(syncing: boolean) {
    if (syncing) {
      this.infoSyncing = syncing;
      this.infoSyncingChange.emit(this.listSyncing);
      // const features = [this.currentFeature.gid];
      if (!this.currentSLLayer) {
        return;
      }

      /* const info: ISelectionInfo = {
        id: UUID.UUID(),
        layer: this.currentSLLayer,
        layerId: this.currentSLLayer.id,
        features: (features),
        selectionMode: 'single'
      }
      if (this.selections !== null) {
        if (this.resultsSvc.CompareSelections(this.selections, info) === true) {
          return;
        }
      }
      this.selections = info;
      this.resultsSvc.Synch(
        {
          channel: this.moment.id,
          source: this.synchProxy.synchId,
          data: {
            moment: this.moment, selections: info
          },
          topic: 'selection-change'
        }
      );
      */

    }
  }
  SetListSynching(isSynching: boolean): void {
    this.listSyncing = isSynching;
    this.listSyncingChange.emit(this.listSyncing);
  }
  SetInfoSynching(isSynching: boolean): void {
    this.infoSyncing = isSynching;
    this.infoSyncingChange.emit(this.infoSyncing);
  }

  SetSelections(event: SynchSelectionsEvent, ignoreSynchState: boolean = false) {

    switch (event.source) {
      case 'results-list':
        if (this.listSyncing || ignoreSynchState) {
          const wasSynching = this.listSyncing;

          if (event.data.selections.features.length > 1) {
            this.listSyncing = false;

          }
          this.isSettingSelections = true;
          this.SetResults(this.slMap, this.slMap.component.layerAPI, this.moment);
          const syncable = this.HandleSelections(event.data.selections);
          this.listSyncing = (ignoreSynchState === true) ? wasSynching : syncable;
          this.isSettingSelections = false;
          this.SetStats();
        }
        break;
      case 'info':
        if (this.infoSyncing || ignoreSynchState) {
          const wasSynching = this.infoSyncing;

          if (event.data.selections.features.length > 1) {
            this.infoSyncing = false;

          }
          this.isSettingSelections = true;
          this.SetResults(this.slMap, this.slMap.component.layerAPI, this.moment);
          const syncable = this.HandleSelections(event.data.selections);
          this.infoSyncing = (ignoreSynchState === true) ? wasSynching : syncable;
          this.isSettingSelections = false;
          this.SetStats();

        }
        break;
    }
    this.Refresh();

    // this.lastSynchEvent = event;

  }
  HandleSelections(info: ISelectionInfo) {
    this.selections = info;
    this.resultsSvc.history.RegisterSelection('popup-control', info.id);
    let i = -1;
    for (const layer of this.results) {
      i += 1;
      if (layer.id === info.layerId) {
        this.SelectLayer(i);
      }
    }
    if (!this.currentLayer) {
      return;
    }
    if (!!info.features) {
      if (info.features.length === 0) {
        info.features[0] = this.currentLayer.features[0].gid;
      }
      if (info.features.length > 0) {
        if (!this.currentFeature) {
          this.currentFeature = info.features[0];
        }
        if (this.currentFeature.gid !== info.features[0]) {
          this.currentFeatureI = 0;
          for (const feature of this.currentLayer.features) {

            if (feature.gid === info.features[0]) {
              break;
            }
            this.currentFeatureI += 1;
          }
          this.currentFeature = this.currentLayer.features[this.currentFeatureI];
          this.currentFeatureI += 1;
          if (this.currentFeature) {
            this.ShowFeature();
          }
          return (info.features.length === 1);
        }
        if (info.features.length > 1) {
          return false;
        }
        return true;

      } else {
        return false;
      }

    }
    this.Refresh();

  }
  SwitchViews() {
    if (this.isLayersView) {
      this.ShowFeature();
    } else {
      this.ShowLayers();
    }
  }
  Refresh() {
    if (this._ready === true) {
      this.cdr.detectChanges();
    }
    /*if(!!this.layerNames) {
      const wasScrolling = this.layersScrolling;
      this.layersScrolling = this.layerNames.nativeElement.scrollHeight > this.layerNames.nativeElement.clientHeight;
      this.layerNames.nativeElement.style.setProperty('--scrollbar-width',this.layersScrolling? 'inherit' : '0px');
      if(wasScrolling !== this.layersScrolling) this.Refresh();
    }*/

  }
}
